import XAPPService from "app/Core/services/XAPPService";
export const GET_CHECKLIST_EMPRESA = "[CHECKLIST_EMPRESA APP] GET CHECKLIST_EMPRESA";
export const CHECKLIST_EMPRESA_WARNING = "[CHECKLIST_EMPRESA APP] CHECKLIST_EMPRESA WARNING";
export const CHECKLIST_EMPRESA_INFO = "[CHECKLIST_EMPRESA APP] CHECKLIST_EMPRESA INFO";
export const CHECKLIST_EMPRESA_ERROR = "[CHECKLIST_EMPRESA APP] CHECKLIST_EMPRESA ERROR";


export function list(_AParams) {

    return (dispatch, getState) => {

        let AContexto = { "meuperfil": { datains: getState().auth.user.data.datains, dataupt: getState().auth.user.data.dataupt } };
        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "ChecklistEmpresa", AActions, "spvwchecklistempresa", ["*"], "SELECIONAR", AConditionsAND, AConditionsOR, 1, AContexto);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_CHECKLIST_EMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: CHECKLIST_EMPRESA_ERROR,
                    payload: error
                });
            });
    };
}